import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import Img from "gatsby-image"

const IndexPage = ({data}) => {
  console.log('test: ', data);
  const edges = data.allMarkdownRemark.edges;
  return (
    <Layout>
      <SEO title="Tajawal Blog" />

      {/* Hero */}
      <div className="hero is-medium has-background">
        <img alt="hero" class="hero-background" src="/hero.jpg" />
        <div className="hero-body">
          <div className="container">
            <h1 className="title is-1">What's your next Destination?</h1>
            <h2 className="subtitle">
              Read about these top destinations shortlisted by our travel experts at Tajawal.
            </h2>
            <Link to="/page-2/">Read Now</Link>
          </div>
        </div>
      </div>

      {/* Blog excerpts */}
      <div className="container blog-home">
        <div className="section">
            {edges.map(({node}, index) => {
              return (
                <div className="columns" key={index}>
                  <div className="column is-two-fifths">
                    <Img className="blog-image" fluid={node.frontmatter.featuredImage.childImageSharp.fluid} />
                  </div>
                  <div className="column blog-content">
                  <h2 className="title is-size-3"><Link to={node.fields.slug} className="has-text-grey-dark blog-title">{node.frontmatter.title}</Link></h2>
                    <div style={{marginTop: -10, marginBottom: 25}}>
                          {node.frontmatter.tags.map((tag, index) => (
                              <span key={index} className="tag is-link is-light" style={{marginRight: 5}}>{tag}</span>
                          ))}
                      </div>
                    <p className="subtitle is-size-5-desktop has-text-grey">{node.excerpt}</p>
                    <p className="has-text-grey-light">{node.frontmatter.date} . {`${node.timeToRead} min read`}</p>
                    <Link to={node.fields.slug}>Read More</Link>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(sort: {fields: frontmatter___date, order: DESC}) {
      edges {
        node {
          frontmatter {
            author
            date(formatString: "MMM DD, YYYY")
            tags
            title
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          html
          excerpt
          fields {
            slug
          }
          timeToRead
        }
      }
    }
  }
`

export default IndexPage
